import { Routes } from '@angular/router';
import { HistoriqueModificationComponent } from './historique-modification.component';

export const HISTORIQUE_MODIFICATION_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'liste',
        pathMatch: 'full',
        data: {
            role: 'ORGANISME',
            menu: { icon: 'history', libelle: 'menu.historique-modification', hide: true }
        }
    },
    {
        path: 'liste',
        component: HistoriqueModificationComponent,
        title: 'menu.historique-modification'
    }
];
